import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import * as XLSX from "xlsx";

import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";
import { t } from "i18next";
import ActionModel from "./ActionModel";
import Filtre from "../Stock/Filtre";

import {
  findvendeursBySocieteApi,
  Vendeurs,
} from "../../_App/Redux/Slices/users/vendeurSlice";
import {
  SelectedOrganisationId,
  SelectedOrganisations,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import Select from "react-select";
import {
  findClientBySocieteApi,
  ListClient,
} from "../../_App/Redux/Slices/client/clientSlice";
import Loader from "../../_Layouts/Loader/Loader";
import { Spinner } from "react-bootstrap";
import TicketDeCaissePaid from "../Caisses/TicketDeCaisse/TicketDeCaissePaid";
import {
  currentpage,
  findPaymentsByTicketApi,
  ListPaymentMouvement,
  mouvementPayementApi,
  totalPages,
  Totaux,
} from "../../_App/Redux/Slices/payments/PaymentSlice";
import _ from "lodash";
import { ListNumberPagecentaines } from "../../_App/Data/ListNumberPage";

export default function Mouvementpaiement() {
  const dispatch = useAppDispatch();
  const [showModalTicket, setShowModalTicket] = useState(false);
  const [ticket_id, setticket_id] = useState<String | null>(null);

  const listMouvementPayement = useAppSelector(ListPaymentMouvement);
  const listgroupedByOrder: Record<string, any[]> = _.groupBy(
    listMouvementPayement,
    (item: any) => item.ticket_id?._id
  );
  const totaux = useAppSelector(Totaux);

  const current_page = useAppSelector(currentpage);
  const vendeurs = useAppSelector(Vendeurs);
  const clients = useAppSelector(ListClient);
  const societe_id = useAppSelector(societeId);
  const totalpages = useAppSelector(totalPages);
  const OrganisationList = useAppSelector(SelectedOrganisations);
  const [date_debut, setdate_debut] = useState("");
  const [date_fin, setdate_fin] = useState("");
  const [NLigne, setNLigne] = useState<any>(100);
  const [spinner, setspinner] = useState(false);
  const [index, setindex] = useState(!current_page ? 0 : current_page);
  const [vendeurOption, setvendeurOption] = useState<any[]>([]);
  const [selectedvendeur, setselectedvendeur] = useState<any[]>([]);
  const [OrganisationOption, setOrganisationOption] = useState<any[]>([]);
  const [selectedorganisation, setselectedorganisation] = useState<any[]>();
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const [clientOption, setclientOption] = useState<any[]>([]);
  const [selectedclient, setselecteclient] = useState<any[]>([]);

  useEffect(() => {
    if (currentOrganisation) {
      setselectedorganisation([currentOrganisation]);
    }
  }, [currentOrganisation]);
  useEffect(() => {
    const today = new Date();
    const lastMonth = new Date(today);
    lastMonth.setMonth(today.getMonth() - 1);

    // Add one day to today

    const formatDate = (date: any) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setdate_debut(formatDate(lastMonth));
    setdate_fin(formatDate(today));
    setspinner(true);
    const data = {
      organisations: selectedorganisation,
      index: 1,
      dateDebut: lastMonth,
      dateFin: today,
      nbligne: NLigne,
      TOexport: false,
    };
    setindex(1);
    dispatch(mouvementPayementApi(data));
  }, []);

  useEffect(() => {
    setvendeurOption(
      vendeurs?.map((option) => ({
        value: option._id,
        label: option.nom,
      }))
    );
  }, [vendeurs]);

  useEffect(() => {
    if (OrganisationList)
      setOrganisationOption(
        OrganisationList?.map((option) => ({
          value: option._id,
          label: option.nom,
        }))
      );
  }, [OrganisationList]);

  useEffect(() => {
    if (clients)
      setclientOption(
        clients?.map((option) => ({
          value: option._id,
          label: option.nom,
        }))
      );
  }, [clients]);

  useEffect(() => {
    if (societe_id) {
      dispatch(findvendeursBySocieteApi(societe_id));
      dispatch(findClientBySocieteApi(societe_id));
    }
  }, [societe_id]);

  useEffect(() => {
    setspinner(false);
  }, [listMouvementPayement]);

  useEffect(() => {
    if (index !== 0) {
      setspinner(true);

      const data = {
        organisations: selectedorganisation,
        index: index,
        dateDebut: date_debut,
        dateFin: date_fin,
        nbligne: NLigne,
        TOexport: false,
      };
      setindex(index);
      dispatch(mouvementPayementApi(data));
    }
  }, [index]);

  const findMouvement = async () => {
    setspinner(true);
    const data = {
      organisations: selectedorganisation,
      index: 1,
      dateDebut: date_debut,
      dateFin: date_fin,
      nbligne: NLigne,
      TOexport: false,
    };
    setindex(1);
    dispatch(mouvementPayementApi(data));
  };

  const handelSelectVendeur = (selectedOption: any) => {
    const listvendeurs = selectedOption.map((item: any) => item.value);
    setselectedvendeur(listvendeurs);
  };
  const handelSelectOrganisation = (selectedOption: any) => {
    const listOrganisations = selectedOption.map((item: any) => item.value);
    setselectedorganisation(listOrganisations);
  };
  const handelSelectClient = (selectedOption: any) => {
    const listclient = selectedOption.map((item: any) => item.value);
    setselecteclient(listclient);
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        findMouvement();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [findMouvement]);

  const exportTable = async () => {
    const data = {
      organisations: selectedorganisation,
      dateDebut: date_debut,
      dateFin: date_fin,
      nbligne: NLigne,
      TOexport: true,
      index: index,
    };

    const resp = await dispatch(mouvementPayementApi(data));
    const dataList = resp?.payload?.data?.dataexport || [];
    const totaux = resp?.payload?.data?.totaux || {};

    const dataListGrouped: Record<string, any[]> = _.groupBy(
      dataList,
      (item: any) => item.ticket_id?._id
    );

    // Feuille 1 : Tickets
    const headers = [
      t("Ticket"),
      t(""),
      t("Organisation"),
      t("Total Ticket"),
      t("Especes"),
      t("Cheques"),
      t("Ticket  cadeaux"),
      t("Credit cards"),
      t("Date"),
    ];

    const rows = Object.entries(dataListGrouped).map(([ticketId, payments]) => {
      const total = payments
        .reduce((acc, item) => acc + (Number(item.montant) || 0), 0)
        .toFixed(3);

      const espece = (
        Number(payments.find((p) => p.payment_method === "Espéces")?.montant) ||
        0
      ).toFixed(3);

      const cheque = (
        Number(payments.find((p) => p.payment_method === "Chéque")?.montant) ||
        0
      ).toFixed(3);

      const cadeau = (
        Number(
          payments.find((p) => p.payment_method === "Tickets cadeaux")?.montant
        ) || 0
      ).toFixed(3);

      const carte = (
        Number(
          payments.find((p) => p.payment_method === "Carte bancaire")?.montant
        ) || 0
      ).toFixed(3);

      return [
        payments[0].ticket_id?.ticket_order?.order_number || "",
        payments[0]?.ticket_id?.ticket_order?.status === "Annulée"
          ? t("Vente annulée")
          : payments[0]?.orderAnnuleNumber || "",
        payments[0]?.organisation_id?.nom || "",
        total,
        espece,
        cheque,
        cadeau,
        carte,
        payments[0]?.createdAt?.split("T")[0] || "",
      ];
    });

    const totalGlobal = dataList
      .reduce((acc: any, item: any) => acc + (Number(item.montant) || 0), 0)
      .toFixed(3);

    rows.push(["", "", "", totalGlobal, "", "", "", "", ""]);
    const worksheetTickets = XLSX.utils.aoa_to_sheet([headers, ...rows]);

    // Feuille 2 : État des paiements
    const dataEtat = [];
    let total = 0;

    if (totaux?.tiket_total_Espece) {
      const val = Number(totaux.tiket_total_Espece);
      dataEtat.push({ Mode: "Espèce", Montant: val.toFixed(3) });
      total += val;
    }

    if (totaux?.tiket_total_Cheque) {
      const val = Number(totaux.tiket_total_Cheque);
      dataEtat.push({ Mode: "Chèque", Montant: val.toFixed(3) });
      total += val;
    }

    if (totaux?.tiket_total_CreditCardt) {
      const val = Number(totaux.tiket_total_CreditCardt);
      dataEtat.push({ Mode: "Carte Crédit", Montant: val.toFixed(3) });
      total += val;
    }

    if (totaux?.tiket_total_GiftCard) {
      const val = Number(totaux.tiket_total_GiftCard);
      dataEtat.push({ Mode: "Ticket Cadeaux", Montant: val.toFixed(3) });
      total += val;
    }

    dataEtat.push({ Mode: "Total", Montant: total.toFixed(3) });

    const worksheetEtat = XLSX.utils.json_to_sheet(dataEtat);

    // Classeur final
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheetTickets, "Tickets");
    XLSX.utils.book_append_sheet(workbook, worksheetEtat, "État des paiements");

    // Format nom de fichier
    const safeDateDebut = date_debut?.replace(/[^\d]/g, "") || "debut";
    const safeDateFin = date_fin?.replace(/[^\d]/g, "") || "fin";

    XLSX.writeFile(workbook, `reglement_${safeDateDebut}_${safeDateFin}.xlsx`);
  };

  return (
    <>
      <div className=" row  bg-white" style={{ padding: "20px" }}>
        <div className="col-2">
          <label>{t("Date debut")}</label>
          <input
            type="date"
            className="form-control "
            value={date_debut}
            onChange={(e) => setdate_debut(e.target.value)}
          />
        </div>

        <div className="col-2">
          <label>{t("Date fin")}</label>
          <input
            type="date"
            className="form-control "
            value={date_fin}
            onChange={(e) => setdate_fin(e.target.value)}
          />
        </div>

        <div className="col-2">
          <label>{t("Organisation")}</label>
          <Select
            isMulti
            options={OrganisationOption}
            isSearchable={true}
            onChange={handelSelectOrganisation}
            value={selectedorganisation?.map((item: any) =>
              OrganisationOption?.find((cat: any) => cat.value === item)
            )}
          />
        </div>
        <div className="col-2">
          <label> {"N des lignes"}</label>
          <select
            onChange={(e) => setNLigne(e.target.value)}
            value={NLigne || 200}
            className="w-100 form-control product-search br-30"
          >
            {ListNumberPagecentaines.map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>
        </div>

        {spinner ? (
          <Spinner animation="border" />
        ) : (
          <div
            className="col-1 mt-4"
            style={{ fontSize: "30px" }}
            onClick={findMouvement}
          >
            {" "}
            <i className="fas fa-search"></i>
          </div>
        )}
        <div className="col-2">
          <button onClick={exportTable} className="btn btn-export">
            <i className="fas fa-file-excel mr-2"></i>
            {t("Export Excel")}
          </button>
        </div>
      </div>

      <div className=" row  mt-5  bg-white  " style={{ padding: "20px" }}>
        {totaux?.tiket_total_Espece && (
          <div className="col-3 mt-3">
            <label>
              {t(" Total Espece")} : {totaux?.tiket_total_Espece}
            </label>
          </div>
        )}

        {totaux?.tiket_total_Cheque && (
          <div className="col-3 mt-3">
            <label>
              {t(" Total Cheques")} : {totaux?.tiket_total_Cheque}
            </label>
          </div>
        )}

        {totaux?.tiket_total_CreditCardt && (
          <div className="col-3 mt-3">
            <label>
              {t(" Total Credit card")} : {totaux?.tiket_total_CreditCardt}
            </label>
          </div>
        )}
        {totaux?.tiket_total_GiftCard && (
          <div className="col-3 mt-3">
            <label>
              {t(" Total Ticket cadeaux")} : {totaux?.tiket_total_GiftCard}
            </label>
          </div>
        )}
      </div>

      <div className="row layout-spacing mt-5">
        <div className="col-lg-12   bg-white  ">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <th colSpan={2}>{t("Ticket")}</th>
                <th>{t("Organisation")}</th>
                <th>{t("Total Ticket")}</th>
                <th>{t("Especes")}</th>
                <th>{t("Cheques")}</th>
                <th>{t("Ticket  cadeaux")}</th>
                <th>{t("Credit cards")}</th>
                <th>{t("Date")}</th>
              </thead>

              <tbody>
                {Object.entries(listgroupedByOrder).map(
                  ([ticketId, payments]) => (
                    <tr key={ticketId}>
                      <td
                        className="lien-bleu-souligne"
                        onClick={async () => {
                          setticket_id(payments[0].ticket_id);
                          await dispatch(
                            findPaymentsByTicketApi(payments[0].ticket_id?._id)
                          );
                          setShowModalTicket(true);
                        }}
                      >
                        {payments[0].ticket_id?.ticket_order?.order_number}
                      </td>
                      <td style={{ color: "red" }}>
                        {payments[0]?.ticket_id?.ticket_order?.status ===
                        "Annulée"
                          ? t("Vente annulée")
                          : payments[0]?.orderAnnuleNumber}
                      </td>
                      <td>{payments[0]?.organisation_id?.nom}</td>
                      <td>
                        {" "}
                        {payments
                          .reduce((acc, item) => {
                            return acc + Number(item.montant) || 0;
                          }, 0)
                          .toFixed(3)}
                      </td>
                      <td>
                        {payments
                          .filter((p) => p.payment_method === "Espéces")
                          .reduce(
                            (total, p) => total + (Number(p.montant) || 0),
                            0
                          )
                          .toFixed(3)}
                      </td>
                      <td>
                        {payments
                          .filter((p) => p.payment_method === "Chéque")
                          .reduce(
                            (total, p) => total + (Number(p.montant) || 0),
                            0
                          )
                          .toFixed(3)}
                      </td>
                      <td>
                        {payments
                          .filter((p) => p.payment_method === "Tickets cadeaux")
                          .reduce(
                            (total, p) => total + (Number(p.montant) || 0),
                            0
                          )
                          .toFixed(3)}
                      </td>
                      <td>
                          {payments
                          .filter((p) => p.payment_method === "Carte bancaire")
                          .reduce(
                            (total, p) => total + (Number(p.montant) || 0),
                            0
                          )
                          .toFixed(3)}
                        
                      </td>
                      <td>{payments[0]?.createdAt.split("T")[0]}</td>
                    </tr>
                  )
                )}

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>

                  <td>
                    <strong>
                      {listMouvementPayement
                        .reduce((acc, item) => {
                          return acc + Number(item.montant) || 0;
                        }, 0)
                        .toFixed(3)}
                    </strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row layout-spacing">
        <PaginationLayout
          index={index}
          nbrpage={current_page}
          totalpages={totalpages}
          setindex={setindex}
        />
      </div>
      <TicketDeCaissePaid
        ShowModal={showModalTicket}
        setShowModal={setShowModalTicket}
        ticket={ticket_id}
      />
    </>
  );
}
